module.exports = __webpack_public_path__ + "static/media/image7.e2611817.jpg";